import React, { Component } from 'react';
import ReactTable from 'react-table';

class DistrictSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applicationsList: this.props.applicationsList,
      householdAppsList: this.props.householdAppsList,
      disSummaryData: []
    }
  }


  getDisSummaryData = (totalApps, selectedApps) => {
    // Create an object to store school-wise data
    let schoolData = {};

    // Iterate through totalApps array
    totalApps.forEach((app) => {
      const schoolName = app.schoolName;

      // Initialize or update school data
      if (!schoolData[schoolName]) {
        schoolData[schoolName] = {
          school: schoolName,
          totalApprovedApplications: 0,
          selectedApplications: 0,
          percentage: 0,
        };
      }

      // Increment totalApprovedApplications count
      schoolData[schoolName].totalApprovedApplications++;
    });

    // Iterate through selectedApps array
    selectedApps.forEach((app) => {
      const schoolName = app.schoolName;

      // Increment selectedApplications count
      if (schoolData[schoolName]) {
        schoolData[schoolName].selectedApplications++;
      } else {
        // If the schoolName is not found in totalApps, create a new entry
        schoolData[schoolName] = {
          school: schoolName,
          totalApprovedApplications: 0,
          selectedApplications: 1,
          percentage: 0,
        };
      }
    });

    // Convert schoolData object to array
    let finalArray = Object.values(schoolData);



    // Calculate percentages
    finalArray.forEach((school) => {
      school.percentage = school.totalApprovedApplications > 0 ? ((school.selectedApplications / school.totalApprovedApplications) * 100).toFixed(1) + '%' : '0%';
    });

    this.setState({ disSummaryData: finalArray })
  }

  componentWillMount() {
    this.getDisSummaryData(this.state.applicationsList, this.state.householdAppsList)
  }

  render() {
    const { onClose } = this.props;



    return (
      <div className="dialog-container">
        <div className="dialog-close" onClick={onClose}>
          <span>&times;</span>
        </div>
        <div className="dialog-title">District Summary</div>
        <div className="dialog-tab-content">
          <ReactTable className="-striped -highlight"
            ref={r => (this.checkboxTable = r)}
            data={this.state.disSummaryData}
            columns={[
              {
                accessor: 'school',
                Header: 'School',
                style: { textAlign: 'center' }
              },
              {
                accessor: 'totalApprovedApplications',
                Header: 'Total Approved Applications',
                style: { textAlign: 'center' }
              },
              {
                accessor: 'selectedApplications',
                Header: 'Selected Applications',
                style: { textAlign: 'center' }
              },
              {
                accessor: 'percentage',
                Header: 'Percentage',
                style: { textAlign: 'center' }
              },
            ]}
            defaultPageSize={8}
            showPagination={false}
            showPaginationTop={false}
            showPaginationBottom={false}
          />
        </div>
      </div>
    );
  }
}

export default DistrictSummary;



// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/districtSummary.jsx